import React from 'react';
import './AppShell.css';

export type MainTab = 'home' | 'deals' | 'messages' | 'boost';

type Props = {
  active: MainTab;
  onTab: (tab: MainTab) => void;
  onPlus: () => void;
  plusLabel?: string;
  messagesBadge?: number;
};

function IconHome({ active }: { active: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"
        stroke="currentColor"
        strokeWidth={active ? 2.2 : 1.8}
        strokeLinejoin="round"
        fill={active ? 'currentColor' : 'none'}
        fillOpacity={active ? 0.18 : 0}
      />
    </svg>
  );
}

function IconDeals({ active }: { active: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01"
        stroke="currentColor"
        strokeWidth={active ? 2.2 : 1.8}
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconMessages({ active }: { active: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H10l-4.2 3.2c-.7.5-1.8 0-1.8-.9V6.5Z"
        stroke="currentColor"
        strokeWidth={active ? 2 : 1.7}
        strokeLinejoin="round"
        fill={active ? 'currentColor' : 'none'}
        fillOpacity={active ? 0.16 : 0}
      />
    </svg>
  );
}

function IconBoost({ active }: { active: boolean }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 3l2.2 5.4L20 10l-4.4 3.2L17 19l-5-3.2L7 19l1.4-5.8L4 10l5.8-1.6L12 3Z"
        stroke="currentColor"
        strokeWidth={active ? 2 : 1.7}
        strokeLinejoin="round"
        fill={active ? 'currentColor' : 'none'}
        fillOpacity={active ? 0.2 : 0}
      />
    </svg>
  );
}

export function BottomTabBar({
  active,
  onTab,
  onPlus,
  plusLabel = 'Создать',
  messagesBadge = 0
}: Props) {
  const badge = Math.max(0, Number(messagesBadge) || 0);
  return (
    <nav className="fc-tabbar" aria-label="Основная навигация">
      <button
        type="button"
        className={'fc-tabbar__item' + (active === 'home' ? ' fc-tabbar__item--active' : '')}
        onClick={() => onTab('home')}
      >
        <IconHome active={active === 'home'} />
        <span>Главная</span>
      </button>
      <button
        type="button"
        className={'fc-tabbar__item' + (active === 'deals' ? ' fc-tabbar__item--active' : '')}
        onClick={() => onTab('deals')}
      >
        <IconDeals active={active === 'deals'} />
        <span>Задания</span>
      </button>
      <button type="button" className="fc-tabbar__plus" aria-label={plusLabel} onClick={onPlus}>
        <span className="fc-tabbar__plus-btn" aria-hidden>
          +
        </span>
      </button>
      <button
        type="button"
        className={'fc-tabbar__item' + (active === 'messages' ? ' fc-tabbar__item--active' : '')}
        onClick={() => onTab('messages')}
      >
        <span className="fc-tabbar__icon-wrap">
          <IconMessages active={active === 'messages'} />
          {badge > 0 ? (
            <span className="fc-tabbar__badge">{badge > 99 ? '99+' : badge}</span>
          ) : null}
        </span>
        <span>Сообщения</span>
      </button>
      <button
        type="button"
        className={'fc-tabbar__item' + (active === 'boost' ? ' fc-tabbar__item--active' : '')}
        onClick={() => onTab('boost')}
      >
        <IconBoost active={active === 'boost'} />
        <span>Буст</span>
      </button>
    </nav>
  );
}
